import { defineComponent as _, ref as l, useTemplateRef as ee, computed as a, onMounted as te, onBeforeUnmount as ie, createElementBlock as y, openBlock as m, mergeProps as C, toHandlers as ae, createElementVNode as r, createVNode as ne, createBlock as N, createCommentVNode as A, unref as R, resolveDynamicComponent as oe, toRaw as se, normalizeClass as D, toDisplayString as I, withCtx as le, createTextVNode as re } from "vue";
import { useMediaQuery as ce, useSwipe as ue } from "@vueuse/core";
import { RevIllustration as de } from "@ds/components/Illustration";
import { RevLink as me } from "@ds/components/Link";
import fe from "../../../icons/generated/IconCheckInCircle.vue2.js";
import ve from "../../../icons/generated/IconInfo.vue2.js";
import he from "../../../icons/generated/IconWarning.vue2.js";
import { useI18n as we } from "@ds/plugin";
import { track as L } from "@ds/tracking/tracking";
import Se from "../../../translations/generic.translations.js";
import { tw as t } from "../../../utils/tailwind.js";
import { TOAST_VISIBILITY_DURATION as Ie, VariantsEnum as c } from "../Toast.constant.js";
const Te = ["aria-live", "role"], pe = { class: "flex items-center justify-between gap-20" }, xe = { class: "flex flex-1 items-center" }, ge = {
  key: 1,
  class: "text-static-default-hi"
}, Ee = { class: "flex-1 py-2" }, be = { class: "text-static-default-mid body-2 w-full min-w-full" }, ye = 50, O = 500, P = 300, Ce = 250, Ue = /* @__PURE__ */ _({
  name: "RevToastItem",
  __name: "ToastItem",
  props: {
    actionLabel: { default: () => {
    } },
    name: {},
    title: {},
    description: { default: () => {
    } },
    variant: { default: () => c.Info },
    iconSrc: { default: "" },
    icon: { default: () => {
    } },
    iconProps: { default: () => ({ alt: "", height: 32, width: 32 }) },
    duration: { default: () => Ie }
  },
  emits: ["close", "action"],
  setup(e, { emit: V }) {
    const f = V, u = l(null), k = ee("toast-container"), i = l(0), v = l(!1), s = l(!1), T = l(!0), h = ce("(min-width: 768px)"), M = {
      info: "polite",
      success: "polite",
      error: "assertive"
    }, B = a(() => M[e.variant]), H = {
      info: t`bg-static-default-hi mood-inverse`,
      success: t`bg-static-default-hi mood-inverse`,
      error: t`bg-static-danger-hi`
    }, U = a(() => [
      t`shadow-long rounded-lg pointer-events-auto min-w-0 overflow-hidden px-16 py-12 md:min-w-300 md:max-w-400`,
      H[e.variant],
      s.value && t`transition-transform duration-300 ease-out`,
      T.value ? t`visible` : t`hidden`
    ]), $ = a(() => [
      t`text-static-default-hi body-1`,
      e.description && t`body-1-bold`
    ]), p = t`mr-16 h-32 max-w-32`, Y = {
      info: "status",
      success: "status",
      error: "alert"
    }, W = a(() => Y[e.variant]), x = a(() => {
      if (e.variant === c.Success)
        return fe;
      if (e.variant === c.Error)
        return he;
      if (e.variant === c.Info && !e.iconSrc)
        return e.icon || ve;
    }), g = a(() => e.variant === c.Info && e.iconSrc ? e.iconSrc : "");
    function n() {
      u.value !== null && window.clearTimeout(u.value), u.value = null;
    }
    function X() {
      f("action"), f("close"), n();
    }
    function E() {
      f("close"), n();
    }
    function w() {
      n(), u.value = window.setTimeout(E, e.duration);
    }
    function j(o) {
      const d = o === "up" && !h.value, S = o === "right" && h.value;
      return d || S;
    }
    function z(o, d, S) {
      s.value = !0, i.value = o === "up" ? -S : -d;
    }
    function F() {
      v.value = !0, i.value = i.value > 0 ? O : -O, setTimeout(() => {
        T.value = !1;
      }, Ce), setTimeout(() => {
        s.value = !1, E();
      }, P);
    }
    function Q() {
      v.value = !0, i.value = 0, setTimeout(() => {
        v.value = !1, s.value = !1;
      }, P);
    }
    const { lengthY: q, lengthX: G, direction: b } = ue(k, {
      threshold: 0,
      passive: !0,
      onSwipe() {
        j(b.value) && z(b.value, G.value, q.value);
      },
      onSwipeEnd() {
        if (i.value === 0) return;
        Math.abs(i.value) > ye ? F() : Q();
      }
    }), J = a(() => h.value ? `translateX(${i.value}px)` : `translateY(${i.value}px)`);
    te(() => {
      w(), L({
        action: "toast",
        context: {
          name: e.name,
          status: "opened"
        }
      });
    }), ie(() => {
      n(), L({
        action: "toast",
        context: {
          name: e.name,
          status: "closed"
        }
      });
    });
    const K = we(), Z = a(
      () => e.actionLabel || K(Se.buttonClose)
    );
    return (o, d) => (m(), y("div", C({
      ref: "toast-container",
      "aria-atomic": "true",
      "aria-live": B.value,
      class: U.value,
      role: W.value,
      style: {
        // we only want set the styles when swiping, to avoid clashing with the transition-group enter classes, hence the undefined
        transform: s.value ? J.value : void 0
      }
    }, ae({
      focusin: n,
      focusout: w,
      mouseleave: w,
      mouseover: n
    }, !0)), [
      r("div", pe, [
        r("div", xe, [
          g.value ? (m(), N(R(de), C({ key: 0 }, e.iconProps, {
            alt: e.iconProps.alt,
            class: p,
            height: e.iconProps.height,
            src: g.value,
            width: e.iconProps.width
          }), null, 16, ["alt", "height", "src", "width"])) : A("", !0),
          x.value ? (m(), y("div", ge, [
            (m(), N(oe(se(x.value)), {
              class: D(p)
            }))
          ])) : A("", !0),
          r("div", Ee, [
            r("span", {
              class: D($.value)
            }, I(e.title), 3),
            r("div", be, I(e.description), 1)
          ])
        ]),
        ne(R(me), {
          underlined: !1,
          onClick: X
        }, {
          default: le(() => [
            re(I(Z.value), 1)
          ]),
          _: 1
        })
      ])
    ], 16, Te));
  }
});
export {
  Ue as default
};
